<template>
    <ams-tag
        v-for="tag in tags"
        :key="tag.label"
        :isDisabled="tag.label === 'Deutschland'"
        isSelected
        @click="onClickTag(tag.key, tag.featureFilter)"
        >{{ tag.label }}
        <template #icon><ms-close /></template>
    </ams-tag>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import useManagedData from '../../composables/useManagedData/useManagedData'
import { useInitializedAmsSearchStore } from '../../store/amsSearch'
import { AmsRequestKeys, FilterKeys } from '../../services/amsSearch/amsSearch.interface'
import AmsTag from '../AmsTag/AmsTag.vue'
import { MsClose } from '@sunrise/icons'
import { managedFilters } from '../AmsVehicleFeatures/vehicleFeaturesHelper'
import { createTags } from './filterTagHelper'

const onResetCity = () => {
    updateManagedData({
        [AmsRequestKeys.Location]: 'deutschland',
        [AmsRequestKeys.LocationName]: 'Deutschland',
        [AmsRequestKeys.Latitude]: null,
        [AmsRequestKeys.Longitude]: null,
    })
}

const onResetMake = () => {
    updateManagedData({
        [AmsRequestKeys.MakeId]: [],
        [AmsRequestKeys.ModelId]: [],
    })
}

const onResetDoors = () => {
    updateManagedData({
        [AmsRequestKeys.DoorsMin]: null,
        [AmsRequestKeys.DoorsMax]: null,
    })
}

const onResetSeats = () => {
    updateManagedData({
        [AmsRequestKeys.SeatsMin]: null,
        [AmsRequestKeys.SeatsMax]: null,
    })
}

const onClickTag = (
    requestKey?: AmsRequestKeys,
    featureFilter?: {
        filterKey: FilterKeys
        featureKey: string
    },
) => {
    // vehicle feature filter
    if (featureFilter) {
        const deselectedFilter = filters.value.find((filter) => filter.key == featureFilter.filterKey.toLowerCase())

        const managedFilterData = deselectedFilter
            ?.getManagedData()
            ?.filter((managedFilters) => managedFilters !== featureFilter.featureKey)

        if (managedFilterData) {
            deselectedFilter?.setManagedData(managedFilterData)
        }

        // other filters
    } else {
        if (requestKey === AmsRequestKeys.LocationName) {
            onResetCity()
        } else if (requestKey === AmsRequestKeys.MakeId) {
            onResetMake()
        } else if (requestKey === AmsRequestKeys.DoorsMin) {
            onResetDoors()
        } else if (requestKey === AmsRequestKeys.SeatsMin) {
            onResetSeats()
        } else {
            updateManagedData({ [String(requestKey)]: null })
        }
    }
}

const store = useInitializedAmsSearchStore()
const filters = computed(() => managedFilters(managedData, store.results.filters))

const { managedData, updateManagedData } = useManagedData(() => store.currentRequest)

const tags = computed(() => createTags(managedData, filters.value, store?.results.selectedValues))
</script>
